<template>
    <div>
        <div class="card_info">
            <el-table id="imgTable" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }"
                border stripe style="width: 100%" :height="height > 0 ? height : ''" :data="tableData" tooltip-effect="dark"
                show-summary :summary-method="getSummaries">
                <template v-for="(item, index) in table">
                    <el-table-column v-if="item.children" :key="`children-${index}`" :label="item.label" align="center"
                        :width="item.width" :prop="item.prop">
                        <template v-for="(item2, index2) in item.children">
                            <el-table-column v-if="item2" :key="index2" :label="item2.label" align="center"
                                :width="item2.width" :prop="item2.prop">
                                <template slot-scope="scope">
                                    <span>{{ scope.row[item2.prop] }}</span>
                                </template>
                            </el-table-column>
                        </template>
                    </el-table-column>
                    <el-table-column v-else :key="`no-children-${index}`" :label="item.label" align="center"
                        :width="item.width" :prop="item.prop">
                        <template slot-scope="scope">
                            <span >{{ scope.row[item.prop] }}</span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>
    </div>
</template>
  
<script>
export default {
    name: "tableMain",
    props: {
        tableData: {
            type: Array,
            default: () => [],
        },
        height: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            table: [
                { label: "开票单位", prop: "cooperativeUnit", status: true, width: "auto" },
                { label: "待结算金额（元）", prop: "settlementAmount", status: true, width: "200" },
                { label: "补差金额（元）", prop: "compensateAmount", status: true, width: "200" },
                { label: "调整金额（元）", prop: "deduction", status: true, width: "auto" },
                { label: "结算金额（元）", prop: "realPay", status: true, width: "auto" },
                { label: "开票金额（元）", prop: "faceAdjustment", status: true, width: "auto" },
            ],
            tableLoading: false,
            needMergeArr: [
                "stationName",
                "businessTime",
                "mianBodyName",
                "materil",
            ],
            rowMergeArrs: [],
        };
    },
    watch: {
        // tableData(val) {
        //     this.rowMergeArrs = this.rowMergeHandle(this.needMergeArr, val);
        // },
    },
    methods: {
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                } else if (index == 1 && index == 2 && index == 3 && index == 4) {
                    sums[index] = '';
                    return
                }

                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return (Number(prev) + Number(curr)).toFixed(2);
                        } else {
                            return prev;
                        }
                    }, 0);
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        },
        objectSpanMethod({ column, rowIndex, columnIndex }) {
            for (let res in this.needMergeArr) {
                if (this.needMergeArr[res] == column.property) {
                    return this.mergeAction(column.property, rowIndex, columnIndex);
                }
            }
        },
        mergeAction(val, rowIndex) {
            let _row = this.rowMergeArrs[val]['rowArr'][rowIndex];
            let _col = _row > 0 ? 1 : 0;
            return [_row, _col];
        },
        rowMergeHandle(arr, data) {
            if (!Array.isArray(arr) && !arr.length) return false;
            if (!Array.isArray(data) && !data.length) return false;
            let needMerge = {};
            arr.forEach((i, idx) => {
                needMerge[i] = {
                    rowArr: [],
                    rowMergeNum: 0,
                };

                if (idx == 0) {
                    data.forEach((item, index) => {
                        // 表格首个数据单独处理
                        if (index === 0) {
                            needMerge[i].rowArr.push(1);
                            needMerge[i].rowMergeNum = 0;
                        } else {
                            if (item[i] === data[index - 1][i]) {
                                needMerge[i].rowArr[needMerge[i].rowMergeNum] += 1;
                                needMerge[i].rowArr.push(0);
                            } else {
                                needMerge[i].rowArr.push(1);
                                needMerge[i].rowMergeNum = index;
                            }
                        }
                    });
                } else {
                    let firstRowArr = needMerge[arr[0]].rowArr;
                    let firstRowArrDeal = [];
                    firstRowArr.forEach((item, index) => {
                        if (item > 0) {
                            firstRowArrDeal.push(index);
                        }
                    });
                    data.forEach((item, index) => {
                        let sign = false;
                        if (firstRowArrDeal.indexOf(index) > 0) {
                            needMerge[i].rowMergeNum = index;
                            sign = true;
                        }
                        // 表格首个数据单独处理
                        if (index === 0) {
                            needMerge[i].rowArr.push(1);
                            needMerge[i].rowMergeNum = 0;
                        } else {
                            if (item[i] === data[index - 1][i]) {
                                if (sign) {
                                    needMerge[i].rowArr.push(1);
                                } else {
                                    if (item[arr[idx - 1]] != data[index - 1][arr[idx - 1]]) {
                                        needMerge[i].rowArr.push(1);
                                        needMerge[i].rowMergeNum = index;
                                    } else {
                                        needMerge[i].rowArr[needMerge[i].rowMergeNum] += 1;
                                        needMerge[i].rowArr.push(0);
                                    }
                                }
                            } else {
                                needMerge[i].rowArr.push(1);
                                needMerge[i].rowMergeNum = index;
                            }
                        }
                    });
                }
            });
            return needMerge;
        },

    }
};
</script>
  